import React, { useState } from 'react';
import { X } from 'lucide-react';
import { GALLERY } from '../lib/butterstone';

const GallerySection = () => {
  const [active, setActive] = useState(null);
  return (
    <section id="gallery" className="section-pad bg-[#F6F5EF]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="text-center mb-12">
          <span className="overline center">Gallery</span>
          <h2 className="font-serif text-4xl md:text-6xl mt-4">A river runs through it</h2>
          <p className="text-[#5E6E60] mt-4 max-w-2xl mx-auto">Moments from the estate — misty mornings, the flowing river, coffee blossoms and the valley viewpoint.</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <button key={i} onClick={() => setActive(g)} className={`group relative overflow-hidden rounded-md ${g.span}`} data-testid={`gallery-item-${i}`}>
              <img src={g.src} alt={g.label} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E3226]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute left-4 bottom-4 text-white text-sm font-medium opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">{g.label}</span>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div className="fixed inset-0 z-[100] bg-[#12201a]/95 flex items-center justify-center p-4" onClick={() => setActive(null)}>
          <button className="absolute top-6 right-6 text-white/80 hover:text-white" onClick={() => setActive(null)}><X size={30} /></button>
          <figure className="max-w-5xl" onClick={(e) => e.stopPropagation()}>
            <img src={active.src} alt={active.label} className="max-h-[80vh] w-auto rounded-md" />
            <figcaption className="text-center text-white/80 mt-4 font-serif text-xl">{active.label}</figcaption>
          </figure>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
